import { RootState } from 'modules/store';
import { ErrorObject } from 'types/global';
import Errors from 'modules/shared/error/errors';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { OIDCData, OIDCPayload } from './oidc.types';
import { OIDCService } from './oidc.service';

export const getOIDCRegistrationData = createAsyncThunk<
  OIDCData,
  undefined,
  {
    state: RootState;
    rejectValue: {} | ErrorObject;
  }
>('oidc/get-registration-data', async (_, { getState, rejectWithValue }) => {
  const { environment: appEnvironment, appToken } = getState().root.global;

  try {
    return await OIDCService.getOCIDRegistration({
      appToken,
      appEnvironment,
    });
  } catch (error: unknown) {
    const errorObj: ErrorObject = error as ErrorObject;

    if (errorObj.response.status === 404) {
      return rejectWithValue(errorObj.data);
    }

    Errors.handle(errorObj);
    return rejectWithValue(errorObj);
  }
});

export const registerForOIDC = createAsyncThunk<
  OIDCData,
  OIDCPayload,
  { state: RootState }
>('oidc/register', async (body, { getState, rejectWithValue }) => {
  const { environment: appEnvironment, appToken } = getState().root.global;

  try {
    return await OIDCService.register({
      appToken,
      appEnvironment,
      body,
    });
  } catch (error: unknown) {
    const errorObj: ErrorObject = error as ErrorObject;

    Errors.handle(error);
    return rejectWithValue(errorObj.data);
  }
});
